import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import TradingPortalFacet from '../abis/TradingPortalFacet';
import { getContractAddress } from '../constants';

export const getTradingPortalFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: TradingPortalFacet,
    address: address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
